import findIndex from 'lodash/findIndex';
import sortBy from 'lodash/sortBy';

import { WALLAROO_OPS_CENTER_REGEX } from '../../constants/wallaroo.constants';

export const hasOpsCenter = (locations = []) => {
  if (!locations?.length) {
    return false;
  }
  const index = findIndex(locations, ({ id }) => id === WALLAROO_OPS_CENTER_REGEX);
  return index > -1;
}

// locations - location objects to base the label off of
// totalNumberOfEdges - Total Number of Edges available to the pipeline
export const getLabelForEdgeLocations = (locations = [], totalNumberOfEdges = 0) => {
  if (!locations?.length) {
    return 'No Edge Locations';
  }
  if (locations.length === 1) {
    return locations[0]?.name || '1 Edge Location';
  }
  if (locations.length >= totalNumberOfEdges) {
    return 'All Edges';
  }
  return `${locations.length} Edges`;
}

export const hasSameLocations = (setToValidate, setToMatchAgainst) => {
  const hasAllMatchedValues = !setToMatchAgainst.map(location => setToValidate.includes(location)).includes(false);

  const hasAllValidatedValues = !setToValidate.map(location => setToMatchAgainst.includes(location)).includes(false);

  return hasAllValidatedValues && hasAllMatchedValues;
}

export const sortEdgeLocations = (locations = []) => {
  if (!locations?.length) {
    return [];
  }
  return sortBy(locations, ({ name }) => name);
}
